module.exports = __webpack_public_path__ + "img/ymkjbanner3.40e00670.png";